import domReady from "@wordpress/dom-ready";
import { createRoot } from "@wordpress/element";
import "./frontend.scss";
import { useState, useEffect } from "react";

domReady(() => {
  const divsToUpdate = document.querySelectorAll(".suzuka-company-block-wrapper");
  divsToUpdate.forEach(function (div) {
    const data = JSON.parse(div.querySelector("pre").innerHTML);
    const root = createRoot(div);
    root.render(<CompanyBlock {...data} />);
  });
});

function CompanyBlock(props) {
  console.log(props);
  return (
    <div className="suzuka-company-block-frontend" style={{ textAlign: props.theAlignment }}>
      {props.contentRows.map((content, index) => {
        return (
          <div className="scb-content-grid" key={`$content-${content}-${index}`}>
            <img src={content.image?.url} />
            <div className="text-container">
              <h3>{content.title}</h3>
              <p>{content.text}</p>
            </div>
          </div>
        );
      })}
    </div>
  );
}
